import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../../models/user/user.interface';

import {
	constants,
	LocalStorageService
} from '@edassist/common';
import {
	AuthenticationService
} from '@edassist/api';

@Injectable({
  providedIn: 'root'
})
export class ImpersonationService {
	isImpersonation: Observable<boolean>;
	isImpersonationSubject: BehaviorSubject<boolean>;

 constructor(
	 protected readonly authService: AuthenticationService
 ) {
		this.isImpersonationSubject = new BehaviorSubject<boolean>(this.getImpersonationEnabled());
		this.isImpersonation = this.isImpersonationSubject.asObservable();
	}

	updateImpersonation(val: boolean): void {
		this.isImpersonationSubject.next(val);
	}

	updateParticipantDetails(user: User): void {
		LocalStorageService.setItem(constants.localStorageKeys.CURRENT_USER_HYBRID, user);
		this.setSiteUserDetails(LocalStorageService.getItem(constants.localStorageKeys.CURRENT_USER_HYBRID).userDetails);
	}

	resetUserDetails(): void {
		const userDetails = { userDetails: LocalStorageService.getItem(constants.localStorageKeys.IMPERSONATION_USER).originalUserDetails};
		LocalStorageService.setItem(constants.localStorageKeys.CURRENT_USER_HYBRID, userDetails);
		this.setSiteUserDetails(LocalStorageService.getItem(constants.localStorageKeys.IMPERSONATION_USER).originalUserDetails);
		LocalStorageService.removeItem(constants.localStorageKeys.IMPERSONATION_USER);
	}

	getImpersonationEnabled(): boolean  {
		return !!LocalStorageService.getItem(constants.localStorageKeys.IMPERSONATION_USER);
	}

	private setSiteUserDetails(baseSiteUserDetails: User): void {
		const baseSiteUserTokens = LocalStorageService.getItem(constants.localStorageKeys.TOKENS_HYBRID)?.tokens;
		if (baseSiteUserDetails && baseSiteUserTokens) {
			const hybridSiteUser = {
				...baseSiteUserDetails,
				...baseSiteUserTokens
			};
			this.authService.handleUserLogin(hybridSiteUser);
		}
	}
}
